import React, {
  useState, Fragment, useEffect, useCallback,
} from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'react-feather';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import { MENUITEMS } from '../sidebar-component/menu';
import searchStorage from '../../../storages/mobx/searchStorage';
import Avatar from '../../../components/Avatar';
import chatStorage from '../../../pages/Chat/chatStorage';

let timer = null;

const SearchHeader = ({ t }) => {
  const {
    searchValue,
    setSearchValue,
    clearSearchValue,
    searchResults,
    loadSearchResults,
    emptyResult,
  } = searchStorage;
  const [searchOpen, setsearchOpen] = useState(false);
  const [searchActive, setsearchActive] = useState(false);

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      // Do whatever when esc is pressed
      setsearchOpen(false);
      handleSearchKeyword('');
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  });

  const deferedSearch = (keyword) => {
    if (timer !== null) {
      clearTimeout(timer);
    }
    if (keyword.length > 3) {
      timer = setTimeout(() => {
        loadSearchResults();
        timer = null;
      }, 1000);
    }
  };

  const handleSearchKeyword = (keyword) => {
    keyword ? addFix() : removeFix();
    const items = [];
    if (keyword && keyword.length > 0) {
      setSearchValue(keyword);
      deferedSearch(keyword);
      checkSearchResultEmpty(items);
    } else {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      clearSearchValue();
    }
  };

  const checkSearchResultEmpty = (items) => {
    const emptyMenu = document.querySelector('.empty-menu');
    if (emptyMenu) {
      if (searchResults.length === 0) {
        emptyMenu.classList.add('is-open');
      } else {
        emptyMenu.classList.remove('is-open');
      }
    }
  };

  const addFix = () => {
    const menu = document.querySelector('.Typeahead-menu');
    if (menu) menu.classList.add('is-open');
  };

  const removeFix = () => {
    clearSearchValue('');
    const menu = document.querySelector('.Typeahead-menu');
    if (menu) menu.classList.remove('is-open');
  };

  const toggleBtn = () => {
    const searchIcon = document.querySelector('.searchIcon');
    if (searchOpen) {
      setsearchOpen(!searchOpen);
      if (searchIcon) searchIcon.classList.add('open');
    } else {
      setsearchOpen(!searchOpen);
      if (searchIcon) searchIcon.classList.remove('open');
    }
  };

  return (
    <>
      <div>
        <form className="form-inline search-form">
          <div className="form-group">
            <input
              className="form-control-plaintext searchIcon"
              type="text"
              placeholder={t('search')}
              value={searchValue}
              onChange={(e) => handleSearchKeyword(e.target.value)}
              onFocus={() => setsearchActive(true)}
              // onBlur={() => setsearchActive(false)}
            />
            <span className="d-sm-none mobile-search" onClick={toggleBtn}>
              <Search />
            </span>

            {searchResults && searchActive && searchResults.length > 0 && (
              <button
                className="closeButton"
                onClick={() => {
                  handleSearchKeyword(null);
                  searchStorage.setSearchedId(`message-${data.conversation_id}-${data.id}`);
                }}
              >
                <i className="fa fa-times fa-2x" />
                {' '}
              </button>
            )}
            <div className={`Typeahead-menu custom-scrollbar ${searchActive ? 'is-open' : ''}`} id="search-outer">
              {searchResults && searchActive && searchResults.length > 0
                ? searchResults.map((data) => (
                  <div
                    className="ProfileCard u-cf"
                    onClick={() => {
                      console.log('Click');
                      chatStorage.changeCurrentChat(data.conversation_id);
                      searchStorage.setSearchedId(`message-${data.conversation_id}-${data.id}`);
                      setsearchActive(false);
                    }}
                  >
                    <div className="ProfileCard-avatar">
                      <Avatar image={(data.account && data.account.avatar) || '/images/user.png'} />
                    </div>
                    <div className="ProfileCard-details">
                      <div className="ProfileCard-realName">
                        <div
                          className="realname"
                        >
                          {(data.account && data.account.name) || 'Unnamed'}
                          {' '}
                          {data.updated_at && (new Date(data.updated_at)).toLocaleDateString()}
                        </div>
                      </div>
                      <div className="ProfileCard-realName">
                        {data.message && data.message.text}
                      </div>
                    </div>
                  </div>
                )) : <div style={{ width: '100%', textAlign: 'center' }}>{emptyResult ? t('Opps!! There are no result found') : '...'}</div> }
            </div>
            {emptyResult && (
            <div className="Typeahead-menu empty-menu">
              <div className="tt-dataset tt-dataset-0">
                <div className="EmptyMessage">
                  {t('Opps!! There are no result found')}
                </div>
              </div>
            </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default translate(observer(SearchHeader));
